<template>
  <div class="yxtbiz-examuser-selector">
    <div class="yxtbiz-examuser-selector__left">
      <div class="clearfix font-size-14">
        <!-- functionCode="group_task_center"
          dataPermissionCode="task_manage_platform" -->
        <yxtbiz-group-org-select
          v-if="groupSelect"
          :placeholder="$t('pc_biz_ote_lbl_plsselectorg')"
          class="mr12 pull-left"
          :multiple="false"
          @change="changeOrg"
          ></yxtbiz-group-org-select>

        <yxt-input
          v-if="projectId || taskId"
          v-model="name"
          size="small"
          :placeholder="$t('pc_biz_udp_tip_searchAccount' /* 请输入姓名/账号搜索 */)"
          searchable
          class="yxtbiz-examuser-selector__keywords"
          @search="userNameSearch"
        >
          <yxt-select
            slot="prepend"
            v-model="keywordType"
            class="width104"
          >
            <yxt-option :label="$t('pc_biz_core_lbl_accnum' /* 账号 */)" value="0" />
            <yxt-option :label="$t('pc_biz_core_lbl_name' /* 姓名 */)" value="1" />
          </yxt-select>
        </yxt-input>

        <yxt-input
          v-else
          v-model="userSearch.name"
          style="width: 240px;"
          class="pull-left"
          :placeholder="$t('biz_ote_enter_account')"
          searchable
          maxlength="50"
          @search="userNameSearch"
        >
        </yxt-input>
      </div>
      <div class="yxtbiz-examuser-selector__main mt16">
        <yxt-table
          :ref="refTable"
          v-loading="loading"
          :data="userTempList"
          :height='tableHeight'
          class="yxtbiz-examuser-selector__table"
          @select-all="selectAll"
          @select="select"
        >
          <yxt-table-column  type="selection"
                            :show-overflow-tooltip="false"
                            width="38"
                            align="right"
                            clear-padding="left-right"></yxt-table-column>
          <yxt-table-column :label="$t('pc_biz_ote_lbl_cnname')" :show-overflow-tooltip="false">
            <template slot-scope="scope">
              <yxt-tooltip effect="dark"
                          placement="top"
                          popper-class="yxtbiz-participants-max-tip"
                          :open-filter="true">
                <div slot="content">
                  <yxtbiz-user-name :name="scope.row.fullName"/>
                  (<span>{{ scope.row.userName }}</span>)
                </div>
                <div class="ellipsis">
                  <yxtbiz-user-name :name="scope.row.fullName"/>
                  (<span>{{ scope.row.userName }}</span>)
                </div>
              </yxt-tooltip>
            </template>
          </yxt-table-column>
          <yxt-table-column :label="$t('pc_biz_ote_lbl_userNo')" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.userNo || '--' }}
            </template>
          </yxt-table-column>
          <yxt-table-column :label="$t('pc_biz_ote_lbl_position')" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.positionName || '--' }}
            </template>
          </yxt-table-column>
        </yxt-table>
      </div>
      <div class="mt16 pr clearfix">
        <yxt-pagination
          class="pull-right"
          :page-size="userSearch.limit"
          :total="count"
          :current-page="page"
          layout="total, prev, pager, next"
          :page-count="totalPage"
          @size-change="sizeChange"
          @current-change="pageChange"
        ></yxt-pagination>
      </div>
    </div>
    <div class="yxtbiz-examuser-selector__right">
      <yxt-scrollbar :fit-height="true">
        <yxt-tag
          :key="item.userId"
          v-for="item in selected"
          class="mr5 mb5 yxtbiz-examuser-selector__tag"
          size="small"
          type="info"
          closable
          @close="deleteItem(item)"
        >
          <span class="flex">
            <yxt-svg class="mr5 v-mid"
                      width="14px"
                      height="24px"
                      :icon-class="'person-center'" />
            <span class="user-selector-tag">
              <yxt-tooltip effect="dark"
                          placement="top"
                          popper-class="yxtbiz-participants-max-tip"
                          :open-filter="true">
                <div slot="content">
                  <yxtbiz-user-name :name="item.fullName"/>
                </div>
                <div class="ellipsis">
                  <yxtbiz-user-name :name="item.fullName"/>
                </div>
              </yxt-tooltip>
            </span>
          </span>
        </yxt-tag>
      </yxt-scrollbar>
      <yxt-button type='text'
                  class="user-clear font-size-12 color-gray-9 hover-primary-6"
                  :disabled="Object.values(this.selected).length === 0"
                  @click="clear"
      >
        {{ $t('pc_biz_ote_btn_clearall') }}
      </yxt-button>
    </div>
  </div>
</template>

<script>
import resizeTable from '../../../user-selector/mixins/resizeTable';
import { getExaminees, postProjectUsers, postGroupMemberUsers } from '../service';

export default {
  name: 'SelectExamUser',
  components: {
  },
  mixins: [resizeTable],
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    // 是否集团化，支持跨机构选择
    groupSelect: {
      type: Boolean,
      default: false
    },
    // 循环考时的 安排的补考批次ID
    batchId: {
      type: String,
      required: false
    },
    // 支持项目内部添加补考人员
    projectId: {
      type: String,
      default: ''
    },
    // 支持项目多班次人员
    taskId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      refTable: 'stb',
      tableHeight: 0,
      page: 1,
      name: '',
      userSearch: {
        name: '',
        limit: 20,
        offset: 0,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      },
      loading: false,
      totalPage: 0,
      count: 0,
      userTempList: [],
      selected: {},
      keywordType: '0'
    };
  },
  created() {
    this.formatModel(this.value);
    this.getUserList();
  },
  methods: {
    changeOrg(org) {
      this.userSearch.queryOrgId = org ? org.orgId : undefined;
      this.getUserList(true);
    },
    filterNode(value, data) {
      return !value || data.label.indexOf(value) !== -1;
    },
    async getUserList(isReset) {
      if (isReset) {
        this.page = 1;
        this.userSearch.offset = 0;
      }

      this.loading = true;

      try {
        let paging = {};
        if (this.taskId || this.projectId) {
          this.userSearch.deleted = 0;
          this.userSearch[this.keywordType === '0' ? 'userName' : 'fullName'] = this.name.trim();

          // 根据 taskId 判断多班次和项目的接口
          const interfaceName = this.taskId ? postGroupMemberUsers : postProjectUsers;
          const result = await interfaceName(this.taskId || this.projectId, this.userSearch);
          this.userTempList = result.datas.map(user => ({
            ...user,
            fullName: user.fullname,
            userName: user.username,
            positionName: user.positionList
          }));

          paging = result.paging;
        } else {
          this.userSearch.name = this.userSearch.name.trim();
          this.userSearch.batchId = this.batchId;

          const result = await getExaminees(this.id, this.userSearch, true);
          this.userTempList = result.datas;
          paging = result.paging;
        }

        this.totalPage = paging.pages;
        this.count = paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.setChecked();
        });
      } catch (error) {
        console.log(error);
      }
    },
    userNameSearch() {
      this.getUserList(true);
    },
    sortChange(sort) {
      this.getUserList();
      return false;
    },
    sizeChange(size) {
      this.userSearch.limit = size;
      this.getUserList(true);
    },
    pageChange(page) {
      this.page = page;
      this.userSearch.offset = (page - 1) * this.userSearch.limit;
      this.getUserList();
    },
    // 选择某个
    select(item, row) {
      let isAdd = item.some(v => {
        return v.userId === row.userId;
      });
      if (!isAdd) {
        delete this.selected[row.userId];
      } else {
        this.selected[row.userId] = row;
      }
      this.outPut();
    },
    // 全选
    selectAll(items) {
      let isAdd = items.length !== 0;
      this.userTempList.forEach(obj => {
        if (!isAdd) {
          delete this.selected[obj.userId];
        } else {
          this.selected[obj.userId] = obj;
        }
      });
      this.outPut();
    },
    // 删除已选择
    deleteItem(item) {
      let row = item;
      for (let index = 0; index < this.userTempList.length; index++) {
        const element = this.userTempList[index];
        if (element.userId === item.userId) {
          row = element;
          break;
        }
      }
      if (row) {
        this.$refs[this.refTable].toggleRowSelection(row, false);
      }
      delete this.selected[item.userId];
      this.outPut();
    },
    // 清空
    clear() {
      let row = null;
      for (const key in this.selected) {
        if (this.selected.hasOwnProperty(key)) {
          for (let index = 0; index < this.userTempList.length; index++) {
            const element = this.userTempList[index];
            if (element.userId === key) {
              row = element;
              break;
            }
          }
          if (row) {
            this.$refs[this.refTable].toggleRowSelection(row, false);
          }
        }
      }
      this.selected = {};
      this.outPut();
    },
    outPut() {
      const selArray = Object.values(this.selected);
      this.$emit('input', selArray);
      this.$emit('select', selArray);
      this.$forceUpdate();
    },
    setChecked() {
      this.userTempList.forEach(obj => {
        if (this.selected.hasOwnProperty(obj.userId)) {
          this.$refs['stb'].toggleRowSelection(obj, true);
        } else {
          this.$refs['stb'].toggleRowSelection(obj, false);
        }
      });
    },
    formatModel(v) {
      this.selected = {};
      if (v) {
        v.forEach(obj => {
          this.selected[obj.userId] = obj;
        });
      }
    }
  },
  watch: {
    value(v) {
      this.formatModel(v);
    }
  }
};
</script>
